export const ExternalLinks = (function () {
	'use strict';

	function init() {
		if (
			typeof wp !== 'undefined' ||
			window.location.host.indexOf('localhost') > -1 ||
			window.location.host.indexOf('spiffstg') > -1 ||
			window.location.host.indexOf('.test') > -1
		)
			return;

		const regex = new RegExp(/https?:\/\/([a-z0-9]+[.])*(spiffstg[.].wpengine|spiff2022[.]wpengine|spiff)[.]com/);

		document.querySelectorAll('a').forEach((link) => {
			const linkIsInternal = regex.test(link.href);

			if (!linkIsInternal) console.log(link.href);

			if (!linkIsInternal) link.setAttribute('target', '_blank');
		});
	}

	return {
		init: init,
	};
})();
